import {differenceInCalendarDays, differenceInMinutes} from 'date-fns'
import { pluck, length, equals, reduce, pipe, filter, propEq, forEach, prop, merge } from 'ramda'
import addWorkerCtrl from '../../manager-app/workforce/managerWorkforce.ctrl'
import addWorkerTpl from '../../manager-app/workforce/managerWorkforce.html'
import '../schedules.css'

import moment from 'moment-timezone'

const getSelected = filter(propEq('selected', true))

const mask = (a, b) => a | b

const encodeDayMask = pipe(
  getSelected,
  pluck('value'),
  reduce(mask, 0)
)

class showJobsController {
  /* @ngInject */
  constructor ($mdDialog, $mdToast, Jobs, Users, ToastService, $scope, Companies, Crews, company, $templateCache, user, Auth) {
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.$templateCache = $templateCache
    this.Jobs = Jobs
    this.Users = Users
    this.Companies = Companies
    this.ToastService = ToastService
    this.Crews = Crews
    this.addToJob = 'add'
    this.$scope = $scope
    this.showLoaderCircle = false
    this.loadingWorkers = false
    this.showShiftDays = false
    this.company = company
    this.phoenixExperience = false
    this.redirectReactApp = !!company.beta_active
    this.days = [
      { name: 'Su', value: 1 },
      { name: 'M', value: 2 },
      { name: 'T', value: 4 },
      { name: 'W', value: 8 },
      { name: 'Th', value: 16 },
      { name: 'F', value: 32 },
      { name: 'S', value: 64 }
    ]
    this.getCompanyJobs()
  }

  getCompanyJobs () {
    this.showLoaderCircle = true
      this.Jobs.getPositionsData(this.company.internal_id)
      .then((data) => {
        this.positions = data.positions
        this.myCrews = this.Crews.getCrews()
        this.myWorkforce = this.Users.fetchOtherWorkforce(this.company.internal_id)
        .then(this.hideLoader())
      })
  }

  showLoader () {
    this.showLoaderCircle = true
  }

  hideLoader () {
    this.loadingWorkers = false
    this.showLoaderCircle = false
  }

  createNewShift (job) {
    this.repost = true
    this.jobToRepost = job
    this.now = new Date()

    this.timezone = job.timezone
    this.timezoneBrowser = moment.tz.guess()

    this.startDate = moment.tz(this.timezone).format()
    let shiftStartMinute = moment.tz((job.start_date || job.startDate), this.timezone).get('minute')
    let shiftStartHour = moment.tz((job.start_date || job.startDate), this.timezone).get('hour')
    this.startTime = moment().tz(this.timezone).set({'hour': shiftStartHour, 'minute': shiftStartMinute, 'second': 0}).toDate()
    this.endDate = moment.tz(this.timezone).format()
    let shiftEndMinute = moment.tz((job.end_date || job.endDate), this.timezone).get('minute')
    let shiftEndHour = moment.tz((job.end_date || job.endDate), this.timezone).get('hour')
    this.endTime = moment().tz(this.timezone).set({'hour': shiftEndHour, 'minute': shiftEndMinute, 'second': 0}).toDate()
    if (this.timezone !== this.timezoneBrowser) {
      this.timezoneDisplay = true
    }
  }

  createNewSchedule(position, schedule) {
    this.repost = true
    this.jobToRepost = merge(position, schedule)
    this.now = new Date()

    this.timezone = position.timezone
    this.timezoneBrowser = moment.tz.guess()

    // this.startDate = moment.tz(this.timezone).format()
    let start = schedule.days[0].start_time.split(':')
    this.startTime = moment.tz(this.startDate, this.timezone).set({'hour': start[0], 'minute': start[1], 'second': 0}).toDate()
    // this.endDate = moment.tz(this.timezone).format()
    let end = schedule.days[0].end_time.split(':')
    this.endTime = moment.tz(this.endDate, this.timezone).set({'hour': end[0], 'minute': end[1], 'second': 0}).toDate()
    if (this.timezone !== this.timezoneBrowser) {
      this.timezoneDisplay = true
    }
  }

  handleOverlap (e) {
    if (!e.status || e.status !== 409) throw e
    let text
    let title

    const users = pipe(
      prop('reason'),
      JSON.parse,
      pluck('name')
    )(e.data)

    title = users + ' has a conflicting shift. Continue putting them on the job anyways?'

    const confirm = this.$mdDialog.confirm()
      .title(title)
      .multiple(true)
      .textContent(text)
      .ariaLabel('Conflict confirm')
      .ok('Yes')
      .cancel('No')

    return this.$mdDialog.show(confirm)
  }

  repostSelector(data) {
    if (this.redirectReactApp) return this.Jobs.repostSchedule(data)
    else return this.Jobs.repost(data)
  }

  showAddWorker (job, selectedShift) {
    this.errors = []
    this.addForm.timeForm.$error = false
    this.addForm.$invalid = false
    this.loadingWorkers = true

    // Creating a new moment start date object and setting the correct date, hours, minutes
    let shiftStartObj = moment(this.startDate)
    shiftStartObj.set({ hour: this.startTime.getHours() , minute: this.startTime.getMinutes(), second: 0 })
    shiftStartObj.tz(this.timezone)

    const formattedShiftStart = shiftStartObj.format()

    // Creating a new moment end date object and setting the correct date, hours, minutes
    let shiftEndObj = moment(this.endDate)
    shiftEndObj.set({ hour: this.endTime.getHours() , minute: this.endTime.getMinutes(), second: 0 })
    shiftEndObj.tz(this.timezone)

    const formattedShiftEnd = shiftEndObj.format()

    let diff = shiftEndObj.diff(shiftStartObj, 'hours', true)

    if (differenceInCalendarDays(this.startDate, this.endDate) > 0) {
      this.loadingWorkers = false
      return this.ToastService.showWarning('End date is before start date')
    }

    let shiftDuration = differenceInMinutes(this.endTime, this.startTime, ) / 60
    if (differenceInCalendarDays(this.endDate, this.startDate) > 0  && shiftDuration < 0) {
      shiftDuration = shiftDuration + 24
    }

    if (shiftDuration < 0) {
      this.loadingWorkers = false
      return this.ToastService.showWarning('Shift start time must before end time')
    } else if (4 > shiftDuration > 0 ) {
      this.loadingWorkers = false
      return this.ToastService.showWarning('Shift must be at least 4 hours')
    } else if (shiftDuration >= 14) {
      this.loadingWorkers = false
      return this.ToastService.showWarning('Shift must be under 14 hours')
    }

    if (diff > 20 && !this.showShiftDays) {
      this.showShiftDays = true
      this.loadingWorkers = false
      return this.ToastService.showWarning('Select the days of the week')
    }

    let confirm = {
      controller: addWorkerCtrl,
      controllerAs: 'add',
      template: addWorkerTpl,
      fullscreen: true,
      multiple: true,
      clickOutsideToClose: true,
      locals: {
        job: job,
        Users: this.Users,
        shift: selectedShift,
        workforce: this.myWorkforce,
        repost: this.repost
      },
      onRemoving: () => {
        this.$templateCache.remove(addWorkerTpl)
      }
    }
    this.$mdDialog.show(confirm).then((addedWorkers) => {
      this.loadingWorkers = false
      if (this.repost) {
        this.showLoader()
        let addedWorkerIds = pluck('external_id', addedWorkers)
        let days = 127
        if (this.showShiftDays) {
          days = encodeDayMask(this.days)
        }
        let repostData = {
          jobId: this.redirectReactApp ? this.jobToRepost.most_recent_job_id : this.jobToRepost.external_id,
          dsb: 0,
          startDate: formattedShiftStart,
          endDate: formattedShiftEnd,
          userIds: addedWorkerIds,
          needed: length(addedWorkers),
          days: days,
          timezone: this.timezone,
          forceLegacyRepost: this.phoenixExperience
        }
        if (this.redirectReactApp) {
          repostData.wage = job.base_wage
          repostData.scheduleId = job.id
        }
        this.repostSelector(repostData)
        .then(
          (response) => {
            let newJobId = response.data.externalId
            if (this.addToJob === 'add') {
              this.Users.clientPutOnJob(addedWorkerIds, newJobId)
              .then(() => {
                this.hideLoader()
                const msg = 'Added Employees To The Job!'
                this.$mdToast.showSimple(msg)
                this.showLoginScreen = true
                this.addedWorkers = []
                return this.$mdDialog.hide('reload')
              })
              .catch((err) => {
                if (!err) return
                this.$mdToast.showSimple(err)
              })
            } else if (this.addToJob === 'approve') {
              this.Users.clientPutOnJob(addedWorkerIds, newJobId, null, true)
              .then(() => {
                this.hideLoader()
                const msg = 'Added Employees and Approved Hours'
                this.$mdToast.showSimple(msg)
                this.showLoginScreen = true
                this.addedWorkers = []
                return this.$mdDialog.hide('reload')
              })
              .catch((err) => {
                if (!err) return
                this.$mdToast.showSimple(err)
              })
            } else if (this.addToJob === 'invite') {
              this.hideLoader()
              this.$mdToast.showSimple('Sent Direct Invites')
              this.showLoginScreen = true
              this.addedWorkers = []
              return
            } else {
              return this.$mdToast.showSimple('Error adding shift')
            }
            return
          },
          () => {
            this.hideLoader()
            this.$mdToast.showSimple('Cancelled job repost')
          }
        )
      } else {
        this.hideLoader()
        this.completedAddWorker = true
        this.addedWorkers = addedWorkers
        return
      }
    }, () => { this.loadingWorkers = false })
    .catch(() => { this.loadingWorkers = false })
  }
}

export default showJobsController
